import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] md:min-h-[760px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20magazine%20cover%20art%20with%20layered%20torn%20paper%20collage%20of%20newspaper%20clippings%2C%20deep%20crimson%20and%20warm%20gold%20tones%2C%20abstract%20spotlight%20beams%2C%20grainy%20texture%2C%20moody%20cinematic%20lighting%2C%20high%20contrast%2C%20artistic%20pop%20collage%20style%2C%20no%20text%2C%20no%20faces%2C%20rich%20warm%20color%20palette&width=1800&height=1000&seq=hlws-hero-cover-01&orientation=landscape"
          alt="黑料网社公共区封面主视觉"
          title="黑料网社 公共区 吃瓜大本营 主视觉"
          className="w-full h-full object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/80 via-foreground-950/55 to-primary-950/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-90" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-8 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="flex flex-col lg:flex-row lg:items-end gap-10 lg:gap-16">
          <div className="w-full lg:max-w-3xl">
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <span className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
                <i className="ri-fire-fill" /> 本期封面
              </span>
              <span className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs font-medium whitespace-nowrap">
                黑料网社 · 公共区
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-6xl xl:text-7xl font-black leading-[1.1] text-background-50">
              黑料网社公共区
              <span className="block text-accent-300 mt-2">吃瓜大本营，老哥开聊</span>
            </h1>

            <p className="mt-7 text-base md:text-lg leading-relaxed text-background-100/90 max-w-2xl">
              点开黑料网社公共区，直接进吃瓜大本营。讨论群里老哥实时开聊，粉丝团蹲新料、跟热评，
              站内社群氛围拉满。想找同好一起扒细节，来这就对了。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
              <a
                href="#campus"
                className="h-12 md:h-14 px-8 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-bold flex items-center justify-center gap-2 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-door-open-line text-lg" /> 进吃瓜大本营
              </a>
              <a
                href="#lounge"
                className="h-12 md:h-14 px-8 rounded-full border-2 border-background-50/50 text-background-50 text-sm md:text-base font-bold flex items-center justify-center gap-2 whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                <i className="ri-chat-3-line text-lg" /> 加入讨论群
              </a>
            </div>
          </div>

          <div className="hidden lg:block w-[300px] shrink-0 animate-float-soft">
            <div className="rounded-lg overflow-hidden border-4 border-background-50 bg-background-50">
              <div className="relative w-full h-[360px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Bold%20magazine%20cover%20style%20abstract%20artwork%20in%20deep%20crimson%20and%20gold%2C%20layered%20geometric%20shapes%20and%20concentric%20circles%2C%20halftone%20grain%20texture%2C%20dramatic%20studio%20lighting%2C%20no%20text%2C%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20rich%20warm%20tones&width=600&height=760&seq=hlws-cover-portrait-01&orientation=portrait"
                  alt="黑料网社本期封面卡片"
                  title="黑料网社 本期封面 热评榜"
                  className="w-full h-full object-top"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-4">
                  <p className="font-heading text-background-50 text-lg font-bold">今日热评接力</p>
                  <p className="text-background-200/85 text-xs mt-1">老哥开聊 · 386 条跟评正在刷新</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-background-50/20 rounded-lg overflow-hidden border border-background-50/20">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-foreground-950/35 backdrop-blur-sm px-5 py-5 md:py-6">
              <p className="font-heading text-2xl md:text-3xl font-black text-accent-300">{stat.value}</p>
              <p className="mt-1 text-xs md:text-sm text-background-100/85">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}